var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "size": "md",
      "centered": "",
      "id": "send-quote-confirmation"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    staticClass: "text-center"
  }, [_c('h5', [_c('strong', [_vm._v("Confirmation")])])]), _c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Send group quote details via email ?")])]), _c('div', {
    staticClass: "confirmation-button-group justify-content-center"
  }, [_c('b-button', {
    staticClass: "cancel",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    staticClass: "confirm-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("Confirm")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }